import { SpinnerOverlay, SpinnerCircle } from '../spinner/spinner.styles';
import { Wrapper } from './page-loader.styles';

const PageLoader = () => (
  <Wrapper>
    <SpinnerOverlay $isFullScreen>
      <SpinnerCircle />
    </SpinnerOverlay>
  </Wrapper>
);

export default PageLoader;
